import script from "./ColumnSku.vue?vue&type=script&lang=ts&setup=true"
export * from "./ColumnSku.vue?vue&type=script&lang=ts&setup=true"

import "./ColumnSku.vue?vue&type=style&index=0&id=640405a7&lang=scss&scoped=true"
import "./ColumnSku.vue?vue&type=style&index=1&id=640405a7&lang=scss"
import "./ColumnSku.vue?vue&type=style&index=2&id=640405a7&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-640405a7"]])

export default __exports__